// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"63":"Pokemon","299":"Pokedex","842":"MoveDex"}[chunkId] || chunkId) + "." + {"63":"14e63e59","299":"16c7653c","787":"1d3bb9bd","842":"b16c007a"}[chunkId] + ".chunk.js";
};